<template lang="html">
  <div class="editor">
    <div ref="toolbar" class="toolbar">
    </div>
    <div ref="editor" class="text">
    </div>
  </div>
</template>

<script>
import E from "wangeditor";
export default {
  name: "editoritem",
  data() {
    return {
      // uploadPath,
      editor: null,
      info_: null,
      formData: {}
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    isClear: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear();
        this.info_ = null;
      }
    },
    value: function (value) {
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
      }
    }
    //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  mounted() {
    this.seteditor();
    this.editor.txt.html(this.value);
  },
  methods: {
    seteditor() {
      let that = this;
      // http://192.168.2.125:8080/admin/storage/create
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      this.editor.customConfig.uploadImgShowBase64 = true; // base 64 存储图片
      // this.editor.customConfig.uploadImgServer =  "http://otp.cdinfotech.top/file/upload_images?file="+that.formData; // 配置服务器端地址
      this.editor.customConfig.uploadImgServer = this.$URL + "/upload/index"; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {
        "Content-Type": "multipart/form-data"
      }; // 自定义 header
      this.editor.customConfig.uploadImgParams = {
        token: sessionStorage.getItem("token")
      };

      this.editor.customConfig.pasteFilterStyle = false;

      this.editor.customConfig.uploadFileName = "file"; // 后端接受上传文件的参数名
      // this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxSize = 1000 * 1024 * 1024; // 将图片大小限制为 2M

      // this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      this.editor.customConfig.pasteTextHandle = function (content) {
        // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
        if (content == "" && !content) return "";
        let str = content;
        //处理的标签里的多余代码
        str = str.replace(/<xml>[\s\S]*?<\/xml>/gi, "");
        str = str.replace('/(\\n|\\r| class=(")?Mso[a-zA-Z]+(")?)/g', "");
        let reg = new RegExp("<!--(.*?)-->", "g");
        str = str.replace(reg, "");
        //str = str.replace(/<style>[\s\S]*?<\/style>/ig, '')
        //str = str.replace(/<\/?[^>]*>/g, '')
        // str = str.replace(/[ | ]*\n/g, '\n')
        // str = str.replace(/&nbsp;/ig, '')
        // console.log("富文本的content", JSON.parse(JSON.stringify(content)));
        // console.log("****str修改后的content str", str);
        // console.log(that.editor.text())
        return str;
      };

      // 配置菜单
      (this.editor.customConfig.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
        "fullscreen" // 全屏
      ]),
        (this.editor.customConfig.uploadImgHooks = {
          before: function (xhr, editor, files) {
            console.log(xhr, editor, files);
            // xhr.setRequestHeader("Content-type","multipart/form-data");
            var formData = new FormData();

            formData.append("file", files[0]);
            formData.append("upload_type", "image");
            that.formData = formData;

            xhr.send(formData);

            //  console.log(formData)
            // that.$axios
            //   .post(
            //     "upload/index?token=" + sessionStorage.getItem("token"),
            //     formData,
            //     {
            //       headers: {
            //         "Content-type": "multipart/form-data"
            //       }
            //     }
            //   )
            //   .then(res => {
            //     console.log(res);
            //   });
          },
          fail: (xhr, editor, result) => {
            // 插入图片失败回调
            console.log(xhr, editor, result);
          },
          success: (xhr, editor, result) => {
            // 图片上传成功回调
            console.log(xhr, editor, result);
          },
          timeout: (xhr, editor) => {
            console.log(xhr, editor); // 网络超时的回调
          },
          error: (xhr, editor) => {
            // 图片上传错误的回调
            console.log(xhr, editor);
          },
          customInsert: (insertImg, result, editor) => {
            // 图片上传成功，插入图片的回调
            //result为上传图片成功的时候返回的数据，这里我打印了一下发现后台返回的是data：[{url:"路径的形式"},...]
            // console.log(result.data[0].url)
            //insertImg()为插入图片的函数
            //循环插入图片
            // for (let i = 0; i < 1; i++) {
            // console.log(result)
            console.log(insertImg, editor, result);
            let url = result.data;
            insertImg(url);
            // }
          }
        });

      this.editor.customConfig.onchange = html => {
        this.info_ = html; // 绑定当前逐渐地值

        this.$emit("change", this.info_); // 将内容同步到父组件中
      };
      // 创建富文本编辑器
      this.editor.create();
    }
  }
};
</script>

<style lang="css">
.editor {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 0;
}

.toolbar {
  border: 1px solid #ccc;
}

.text {
  border: 1px solid #ccc;
  height: 500px;
}

.wangEditor-container .wangEditor-txt blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

.wangEditor-container .wangEditor-txt table {
  border: none;
  border-collapse: collapse;
}

.wangEditor-container .wangEditor-txt table td,
.wangEditor-container .wangEditor-txt table th {
  border: 1px solid #f1f1f1;
  padding: 3px 5px;
  min-width: 50px;
  height: 20px;
}

.wangEditor-container .wangEditor-txt pre {
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  padding: 10px;
  margin: 5px 0px;
  font-size: 0.8em;
  border-radius: 3px;
}
</style>